const employment = {
    employmentPhrase1:'Interested in being part of democratizing art and promoting culture?',
    employmentPhrase2:'Send us a message through our contact-us form and we will get back to you!',
};

module.exports = employment;
